import type { DayKind, GridCell } from './types'

export const MONTH_NAMES = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
]

export const WEEKDAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']

export const MONTHS_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
]

export const WEEKDAYS_SHORT = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']

export function typeToKind(typeId: number): DayKind {
  switch (typeId) {
    case 2:
      return 'weekend'
    case 3:
    case 4:
      return 'holiday'
    case 5:
      return 'short'
    case 6:
      return 'transfer'
    default:
      return 'work'
  }
}

export function typeToLabel(typeId: number): string {
  switch (typeId) {
    case 2:
      return 'Выходной'
    case 3:
    case 4:
      return 'Праздник'
    case 5:
      return 'Сокращённый'
    case 6:
      return 'Перенос'
    default:
      return 'Рабочий'
  }
}

export function formatHeaderDate(date: Date): string {
  const dayName = WEEKDAYS_SHORT[date.getDay()]
  const day = date.getDate()
  const month = MONTHS_GENITIVE[date.getMonth()]
  return `${dayName}, ${day} ${month}`
}

export function buildMonthGrid(
  year: number,
  month: number,
  dayMap: Map<number, { type_id: number; note: string }>,
  today: Date,
): GridCell[] {
  const daysInMonth = dayMap.size || new Date(year, month, 0).getDate()
  const firstWeekday = (new Date(year, month - 1, 1).getDay() + 6) % 7
  const todayY = today.getFullYear()
  const todayM = today.getMonth() + 1
  const todayD = today.getDate()
  const cells: GridCell[] = []

  for (let i = 0; i < 42; i++) {
    if (i < firstWeekday || i >= firstWeekday + daysInMonth) {
      cells.push({
        day: null,
        typeId: 1,
        kind: 'work',
        label: '',
        note: '',
        isToday: false,
      })
      continue
    }
    const dayNum = i - firstWeekday + 1
    const info = dayMap.get(dayNum) || { type_id: 1, note: '' }
    cells.push({
      day: dayNum,
      typeId: info.type_id,
      kind: typeToKind(info.type_id),
      label: typeToLabel(info.type_id),
      note: info.note || '',
      isToday: year === todayY && month === todayM && dayNum === todayD,
    })
  }
  return cells
}

export function parseDayMap(
  days: { date: string; type_id?: number; note?: string }[],
): Map<number, { type_id: number; note: string }> {
  const map = new Map<number, { type_id: number; note: string }>()
  for (const d of days) {
    const parts = String(d.date || '').split('.')
    if (parts.length !== 3) continue
    const dayNum = parseInt(parts[0], 10)
    if (!Number.isFinite(dayNum)) continue
    map.set(dayNum, { type_id: Number(d.type_id) || 1, note: d.note || '' })
  }
  return map
}

export function cellNoteText(typeId: number, note: string): string | null {
  if (typeId === 5) return '−1 ч'
  if ((typeId === 3 || typeId === 4) && note) {
    return note.length > 10 ? `${note.slice(0, 10).trim()}…` : note
  }
  return null
}
